import { render, staticRenderFns } from "./ResourceMapComponent.vue?vue&type=template&id=186b4346"
import script from "./ResourceMapComponent.vue?vue&type=script&lang=js"
export * from "./ResourceMapComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports